import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";

export default function PricingCard({ plan, index = 0, dense = false }) {
  const isRec = !!plan.recommended;
  return (
    <div
      data-testid={`pricing-card-${plan.id}`}
      className={`relative flex flex-col border ${isRec ? "border-brand-black" : "border-brand-gray/25"} bg-white p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_60px_-30px_rgba(0,0,0,0.35)]`}
    >
      {isRec && (
        <div className="absolute -top-3 left-6 inline-flex items-center gap-2 bg-brand-black text-white text-[10px] tracking-[0.24em] uppercase font-semibold px-3 py-1.5">
          Recommended
          <span className="h-1.5 w-1.5 rounded-full bg-brand-blue" />
        </div>
      )}

      <div className="eyebrow text-brand-gray">Package {String(index + 1).padStart(2, "0")}</div>
      <h3 className="mt-3 text-[22px] md:text-2xl font-bold tracking-tight text-brand-black">{plan.name}</h3>

      <div className="mt-4">
        {plan.priceLabel && (
          <div className="text-[11px] tracking-[0.14em] uppercase text-brand-gray mb-1">{plan.priceLabel}</div>
        )}
        <div className="flex items-baseline gap-2">
          <span className={`${plan.price.length > 7 ? "text-3xl md:text-[34px]" : "text-4xl md:text-5xl"} font-bold tracking-tight num-tick text-brand-black`}>
            {plan.price}
          </span>
          <span className="text-[13px] text-brand-gray tracking-tight">{plan.unit}</span>
        </div>
      </div>

      <p className={`mt-4 text-[14px] leading-relaxed text-brand-gray ${dense ? "line-clamp-3" : ""}`}>
        {plan.intro}
      </p>

      <div className="mt-6 h-px bg-brand-gray/20" />

      <div className="mt-5">
        <div className="eyebrow text-brand-gray">Typical scope may include</div>
        <ul className="mt-4 space-y-2.5">
          {plan.includes.map((i) => (
            <li key={i} className="flex items-start gap-2.5">
              <span className="mt-1 shrink-0 h-4 w-4 rounded-full bg-gradient-to-br from-brand-blue to-brand-violet flex items-center justify-center">
                <Check className="h-2.5 w-2.5 text-white" strokeWidth={3} />
              </span>
              <span className="text-[13.5px] leading-snug text-brand-black/85">{i}</span>
            </li>
          ))}
        </ul>
      </div>

      {plan.bestFor && (
        <div className="mt-5 text-[12.5px] leading-relaxed text-brand-gray">
          <span className="text-brand-black/80 font-medium">Best for. </span>{plan.bestFor}
        </div>
      )}

      {plan.quoteNote && (
        <div className="mt-4 border-l-2 border-brand-blue/50 pl-3">
          <p className="text-[12px] leading-relaxed text-brand-gray">
            <span className="text-brand-black/80 font-medium">Quote note. </span>{plan.quoteNote}
          </p>
        </div>
      )}

      <div className="mt-5 pt-5 border-t border-brand-gray/20">
        <div className="eyebrow text-brand-gray">Payment</div>
        <p className="mt-2 text-[12.5px] leading-relaxed text-brand-black/80">{plan.payment}</p>
        {plan.note && (
          <p className="mt-2 text-[11.5px] leading-relaxed text-brand-gray italic">{plan.note}</p>
        )}
      </div>

      <div className="mt-6">
        <Link
          to={`/contact?plan=${plan.id}`}
          data-testid={`pricing-cta-${plan.id}`}
          className={`group inline-flex w-full items-center justify-between px-5 py-3.5 text-[13px] font-bold tracking-tight transition-all ${
            isRec
              ? "bg-brand-black text-white hover:bg-brand-violet"
              : "border border-brand-black text-brand-black hover:bg-brand-black hover:text-white"
          }`}
        >
          {plan.cta}
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>
    </div>
  );
}
